/**
 * Uint8Array → Base64（用于提交网口 ESC/POS 任务）
 */
export function uint8ToBase64(bytes: Uint8Array): string {
  let binary = ''
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i])
  }
  return btoa(binary)
}

function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

export interface WaitPrintJobOptions {
  maxWaitMs?: number
  intervalMs?: number
}

/**
 * 轮询打印任务状态直至终态或超时
 */
export async function waitPrintJobDone(
  getStatus: () => Promise<{ status: string; errorMessage?: string }>,
  options: WaitPrintJobOptions = {}
): Promise<{ status: string; errorMessage?: string }> {
  const maxWaitMs =
    typeof options.maxWaitMs === 'number' ? options.maxWaitMs : 15000
  const intervalMs =
    typeof options.intervalMs === 'number' ? options.intervalMs : 500
  const deadline = Date.now() + maxWaitMs
  let last: { status: string; errorMessage?: string } = { status: 'UNKNOWN' }
  while (Date.now() < deadline) {
    last = await getStatus()
    if (last.status === 'DONE' || last.status === 'FAILED') {
      return last
    }
    await sleep(intervalMs)
  }
  return last
}
